import {lazy} from 'react';

export const RoomViewAsync = lazy(() =>
    import('./RoomView')
);
